module.exports = __webpack_public_path__ + "img/error_background.0b530a8e.jpg";